@if (visible()) {
  <div
    class="ui-message"
    [class]="'ui-message--' + variant()"
    [class.ui-message--no-margin-bottom]="noMarginBottom()"
    [attr.role]="ariaRole()"
    [attr.aria-live]="ariaRole() === 'status' ? 'polite' : null"
    [attr.aria-atomic]="'true'"
  >
    <!-- Ícono de variante -->
    <svg
      class="ui-message__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path [attr.d]="iconPath()" />
    </svg>

    <!-- Contenido principal -->
    <div class="ui-message__body">
      @if (title()) {
        <p class="ui-message__title">{{ title() }}</p>
      }

      @if (message()) {
        <p class="ui-message__text">{{ message() }}</p>
      }

    </div>

    <!-- Botón de cierre -->
    @if (closable()) {
      <button
        type="button"
        class="ui-message__close"
        aria-label="Cerrar mensaje"
        (click)="onClose()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    }
  </div>
}
